module.exports = require('./helpers/bundle-url').getBundleURL('2N0CQ') + "logo.c51670a8.svg";